
/**
 * 下拉树
 * wangj
 */

const SgiFormComboxTreeEO = function () {
    return {
        alwBlk: true,//是否允许为空
        // c:"value",//树显示字段名
        ctlH: 0,//组件高度
        ctlN: "下拉树",//控件名称
        ctlW: 24,//组件宽度
        desId: "EP_EO_NUI_0001",//描述GUID
        isDis: false,//是否禁用
        lblAlg: "right",//设置标签位置
        lblW: 6,//标签宽度
        mulSel: false,//设置是否允许多选
        inpPopTe: "--请选择--",
        // n:"子系统菜单",//名称
        // sNo:10,//排序号
        // scId:"SD_SC_PUB_test1",//下拉窗列表值在标准代码中的id
        te: "下拉树",//显示名称
        // saveKey:'value',//保存属性名
        // showKey:'title',//显示属性名
        // insName:'EOCat',//实例名
        // autoSel:true,//自动选择状态

        // isGw:false,//延伸状态
        // isHdn:false,//隐藏状态
        // isLbl:true,//是否显示标签
        // isRead:true,//是否只读
        // isSrp:true,//键盘过滤状态
        // maxL:0,//最大长度
        // minL:0,//最小长度
        // msfTgt:"qtip",//提示信息位置
        // t:"comboxTree",//类型
        // useTim:0,//使用次数
        // visible:true,
        // x:"0",//X轴位置
        // y:"0",//Y轴位置
    }
}

export { SgiFormComboxTreeEO };
export default SgiFormComboxTreeEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormComboxTreeEO.js